module.exports = __webpack_public_path__ + "img/banner-centurion.fd433af3.png";